import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { appClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";
import { ActivityLogInterface } from "./dto";

const getRecruiterActivity = async (): Promise<ActivityLogInterface[]> => {
  const { data } = await appClient.httpClient.get(PATHS.recruiter.activity);
  return data as ActivityLogInterface[];
};

export const useGetRecruiterActivity = () => {
  const query = useQuery<ActivityLogInterface[], AxiosError>({
    queryKey: [QueryKeys.ACTIVITY],
    queryFn: () => getRecruiterActivity(),
  });

  return query;
};
